import React from "react"
import Toast from "react-bootstrap/Toast"



const ToastMessage = (props) => {

 //const [show, setShow] = useState(false);

 const { title, message } = props

 return (
   <div
    className="position-relative"
   >
   <Toast
    {...props}
    >
     <Toast.Header>
     {title}
     </Toast.Header>
     <Toast.Body>
      {message}
     </Toast.Body>
   </Toast>
   </div>
 );
}



export default ToastMessage
